<template>
  <a-collapse v-model:activeKey="activeKey" class="collapse" accordion>
    <a-collapse-panel key="1" :header="`Llamadas en cola (${data?.queued?.length || 0})`">
      <template #extra>
        <a-tooltip>
          <template #title>Llamadas que están esperando ser atendidas por un usuario.</template>

          <InfoCircleOutlined />
        </a-tooltip>
      </template>

      <a-table
        row-key="id"
        size="middle"
        :columns="callsInQueueColumns"
        :data-source="data.queued"
        :scroll="{ y: 300 }"
        :pagination="false"
      >
        <template #queueTime="{ record }">
          <QueueTimeCell :record="record" />
        </template>
      </a-table>
    </a-collapse-panel>

    <a-collapse-panel key="2" :header="`Estado de llamadas (${data?.other?.length || 0})`">
      <template #extra>
        <a-tooltip>
          <template #title>
            <strong>Evaluando:</strong> Reconocimiento de voz humana
            <br />
            <strong>Marcando:</strong> Timbrado de llamadas
          </template>

          <InfoCircleOutlined />
        </a-tooltip>
      </template>

      <a-table
        row-key="id"
        :columns="callsStateColumns"
        :data-source="data.other"
        :scroll="{ y: 300 }"
        :pagination="false"
      />
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { ref } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { callsInQueueColumns, callsStateColumns } from "@/app/strategies/utils/constants";

import QueueTimeCell from "./cells/QueueTimeCell.vue";

export default {
  components: {
    QueueTimeCell,
    InfoCircleOutlined,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const activeKey = ref(2);
    const tabStyle = { backgroundColor: "white" };

    return { callsInQueueColumns, callsStateColumns, activeKey, tabStyle };
  },
};
</script>

<style lang="sass" scoped>
.collapse
  border-color: transparent
</style>
